import React from "react";

export default function About() {
    return (
        <div data-testid="about-page" className="px-6 md:px-12 lg:px-20 py-20 md:py-32">
            {/* Hero */}
            <div className="grid md:grid-cols-12 gap-12 mb-20 md:mb-28">
                <div className="md:col-span-7">
                    <div className="eyebrow text-[#B8860B] mb-6">About</div>
                    <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[0.95] mb-10">
                        Kindness <em className="italic">is</em> a movement.
                    </h1>
                    <p className="text-lg md:text-xl text-black/70 font-light leading-relaxed">
                        Welcome to <span className="italic">The Gift of Kindness Podcast</span>, where every story has the power to inspire, every conversation has the ability to heal, and every act of kindness can change a life.
                    </p>
                </div>
                <div className="md:col-span-5">
                    <img
                        src="https://images.unsplash.com/photo-1478737270239-2f02b77fc618?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
                        alt="Studio"
                        className="w-full h-[520px] md:h-[600px] object-cover"
                    />
                </div>
            </div>

            {/* Body */}
            <div className="grid md:grid-cols-12 gap-12 mb-24 md:mb-32">
                <div className="md:col-span-3">
                    <div className="eyebrow text-[#B8860B] md:sticky md:top-32">Our Story</div>
                </div>
                <div className="md:col-span-8 md:col-start-5 space-y-8 text-lg text-black/70 font-light leading-relaxed max-w-3xl">
                    <p>
                        This podcast was created to be a place of hope, faith, restoration, and purpose. Here, we have honest conversations with people from all walks of life — entrepreneurs, artists, pastors, authors, community leaders, survivors, and everyday heroes who have overcome life's greatest challenges.
                    </p>
                    <p>
                        At <span className="italic">The Gift of Kindness Podcast</span>, we believe that kindness is more than a simple act — it's a movement. It's the bridge that connects broken hearts to healing, pain to purpose, and struggle to victory. Our mission is to encourage, empower, and inspire people to rise above rejection, trauma, adversity, and fear while discovering the greatness God has placed within them.
                    </p>
                    <p>
                        Whether we're discussing faith, personal growth, business, relationships, mental wellness, community outreach, prison ministry, homelessness, or inspiring testimonies, our goal is simple: to leave every listener stronger, wiser, and more hopeful than when they arrived.
                    </p>
                    <p>
                        So, wherever you're listening from — thank you for being part of our family. Get comfortable, open your heart, and prepare to be encouraged.
                    </p>
                    <p className="font-serif italic text-black/85 text-xl md:text-2xl leading-snug border-l-2 border-[#D4AF37] pl-6">
                        This is <span className="not-italic font-sans text-lg tracking-[0.14em] uppercase text-[#B8860B]">The Gift of Kindness Podcast</span> — where kindness is contagious, purpose is awakened, and every voice has the power to make a difference.
                    </p>
                </div>
            </div>

            {/* Pillars */}
            <div className="border-t border-black/10 pt-20 md:pt-24 grid md:grid-cols-3 gap-12 mb-24">
                {[
                    { n: "01", t: "Grow", b: "Personal growth, faith, business, and the small daily choices that compound into a life of purpose." },
                    { n: "02", t: "Heal", b: "Honest conversations about trauma, mental wellness, restoration — and the tender work of putting a heart back together." },
                    { n: "03", t: "Inspire", b: "Everyday heroes and quiet warriors sharing testimonies that turn pain into power and struggle into victory." },
                ].map((b) => (
                    <div key={b.n}>
                        <div className="font-serif text-6xl text-[#D4AF37] mb-4">{b.n}</div>
                        <h3 className="font-serif text-2xl tracking-tight mb-4">{b.t}</h3>
                        <p className="text-black/60 font-light leading-relaxed">{b.b}</p>
                    </div>
                ))}
            </div>

            {/* Closing rally cry */}
            <div className="bg-[#0A0A0A] text-white -mx-6 md:-mx-12 lg:-mx-20 px-6 md:px-12 lg:px-20 py-20 md:py-28">
                <div className="max-w-4xl">
                    <div className="eyebrow text-[#D4AF37] mb-8">The Invitation</div>
                    <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] tracking-tight">
                        Let's <em className="italic text-[#D4AF37]">grow</em>.
                        <br />
                        Let's <em className="italic text-[#D4AF37]">heal</em>.
                        <br />
                        Let's <em className="italic text-[#D4AF37]">inspire</em>.
                    </h2>
                    <p className="mt-10 text-white/70 font-light text-xl">
                        One conversation at a time.
                    </p>
                </div>
            </div>
        </div>
    );
}
